<template>
  <div v-if="category">
    <b-row>
      <b-col>
        <b-text-input-validated label="Category" v-model="category.name" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h3 class="tsny_header">
          Subcategories
          <b-button class="tsny_button" @click="addSubcategory">+</b-button>
        </h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <sub-category
          v-for="(subCategory, index) in category.subcategories"
          :key="index"
          :sub-category="subCategory"
          @delete-subcategory="deleteSubcategory(index)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BTextInputValidated from "../../FormInputs/BTextInputValidated";
import SubCategory from "./SubCategory";

export default {
  name: "CategoryForm",
  components: {
    BTextInputValidated,
    SubCategory
  },
  props: {
    category: {
      type: Object,
      default: null
    }
  },
  methods: {
    addSubcategory() {
      this.category.subcategories.push({
        name: "",
        abbreviation: ""
      });
    },
    deleteSubcategory(index) {
      this.category.subcategories.splice(index, 1);
    }
  }
};
</script>

<style scoped></style>
